/* eslint-disable no-useless-catch */
import { Constants, Util, Alert } from "@wizepe/wize-admin";

import moment from "moment";
import "moment/locale/es";
moment.locale("es");

import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

import * as pdfFonts from 'pdfmake/build/vfs_fonts'

// cubre ambos formatos de exportación (CJS/ESM)
pdfMake.vfs = (pdfFonts?.pdfMake?.vfs) || (pdfFonts?.vfs)

import { mapGetters } from 'vuex'

import { Helpers } from "@/core/utils";

import { QuoteService } from "@/core/services";

export default {
  methods: {
    getIdentifierType(key) {
      return Util.searchValue(key, Constants.IdentifierType);
    },
    async generatePDF(response, preview) {
      const customerIdentifierType = this.getIdentifierType(
        response.customerIdentifierType
      ).label;
      const customerIdentifier = response.customerIdentifier;

      const customerNameType =
        response.customerIdentifierType == Constants.IdentifierType.RUC.key
          ? "Razón social"
          : "Nombre";
      const customerName = response.customerFullName;

      const customerAdrress = response.customerAddress;
      const customerContact = response.customerContact;
      const observations = response.observations;
      const offerValidity = response.offerValidity;
      const deliveryTime = response.deliveryTime;
      const paymentMethod = response.paymentMethod;

      let logoBaseUrl = this.getConfValue("LOGO_IMAGE")

      let logoBase64 = await this.getImageToPdf(logoBaseUrl);

      let content = [];

      content.push({
        text: `COTIZACIÓN N° ${response.correlationId}`,
        style: "title",
      });

      content.push({
        text: [
          {
            text: moment(new Date()).format("D [de] MMMM [de] YYYY"),
            alignment: "right",
          },
        ],
        margin: [0, 0, 0, 40],
      });

      content.push({
        text: [
          { text: `${customerIdentifierType}: `, bold: true },
          customerIdentifier,
        ],
        margin: [0, 0, 0, 4],
      });

      content.push({
        text: [{ text: `${customerNameType}: `, bold: true }, customerName],
        margin: [0, 0, 0, 4],
      });

      if (customerAdrress) {
        content.push({
          text: [{ text: "Dirección: ", bold: true }, response.customerAddress],
          margin: [0, 0, 0, 4],
        });
      }

      if (customerContact) {
        content.push({
          text: [{ text: "Contacto: ", bold: true }, response.customerContact],
          margin: [0, 0, 0, 4],
        });
      }

      content.push({ text: "\n" });

      content.push({
        text: "Estimados Señores. Por medio de la presente, y de acuerdo a su solicitud, sometemos a su consideración nuestra oferta como sigue:",
      });

      content.push({ text: "\n" });

      content.push({
        style: "table",
        table: {
          headerRows: 1,
          widths: ["auto", 300, 70, 70],
          body: this.getTableData(response),
        },
        margin: [0, 0, 0, 15],
      });

      content.push({
        text: "Sin otro particular y en espera de su aceptación a la presente, quedamos a su disposición para cualquier consulta que ustedes estimen conveniente.",
      });

      content.push({ text: "\n\n" });

      content.push({
        text: "CONDICIONES GENERALES", margin: [0, 0, 0, 4], bold: true
      });

      content.push({
        text: [{ text: "Precios: ", bold: true }, "Incluyen IGV"],
        margin: [0, 0, 0, 4],
      });

      if(offerValidity) {
        content.push({
          text: [{ text: "Validez de la oferta: ", bold: true }, offerValidity],
          margin: [0, 0, 0, 4],
        });
      }

      if(deliveryTime) {
        content.push({
        text: [{ text: "Plazo de entrega: ", bold: true }, deliveryTime],
        margin: [0, 0, 0, 4],
      });
      }

      if(paymentMethod) {
        content.push({
          text: [{ text: "Forma de pago: ", bold: true }, paymentMethod]
        });
      }

      content.push({ text: "\n\n" });

      if (observations) {
        content.push({
          text: "OBSERVACIONES", margin: [0, 0, 0, 4], bold: true
        });
        content.push({
          text: observations,
          margin: [0, 0, 0, 4],
        });
      }

      content.push({ text: "\n\n\n" });

      content.push({
        text: response.createdByName,
        alignment: "right",
        margin: [0, 0, 0, 4],
      });

      content.push({
        text: `Cel: ${this.getConfValue('MOBILE')}`,
        alignment: "right"
      });


      if (preview) {
        content.unshift({
          style: "alert",
          table: {
            headerRows: 1,
            widths: [515],
            body: [[{ text: "Éste documento no tiene validez." }]],
          },
        });
      }
      const self = this;
      const quoteContent = {
        content,
        styles: {
          title: {
            fontSize: 22,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 40],
          },
          content: {
            fontSize: 12,
            margin: [0, 0, 0, 10],
          },
          table: {
            fontSize: 12,
            margin: [0, 0, 0, 15],
          },
          total: {
            fontSize: 16,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          footer: {
            fontSize: 14,
            italic: true,
          },
          label: {
            fontSize: 10,
            bold: true,
          },
          alert: {
            fontSize: 10,
            margin: [0, 0, 0, 15],
            fillColor: "#e82c1e",
            alignment: "center",
            bold: true,
            color: "#ffffff",
          },
        },
        defaultStyle: {
          color: "#3e4657"
        },
        pageSize: "A4",
        pageMargins: [40, 80, 40, 60],
        header: [
          {
            columns: [
              {
                text: {
                  text: self.getWebsiteUrl(),
                  link: self.getWebsiteUrl(),
                },
                alignment: "right",
                color: self.getConfValue("COLOR_PRIMARY"),
                bold: true,
                margin: [40, 35, 40, 0],
              },
            ]
          },
          {
            canvas: [
              { type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 },
            ],
            margin: [40, 5, 40, 0],
          },
        ],
        footer: function (currentPage) {
          return [
            {
              canvas: [
                { type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 },
              ],
              margin: [40, 0, 40, 5],
            },
            {
              columns: [
                {
                  margin: [40, 0, 40, 0],
                  text: currentPage.toString(),
                  color: self.getConfValue("COLOR_PRIMARY"),
                },
                {
                  margin: [40, 0, 40, 0],
                  text: "Cotización",
                  alignment: "right",
                  color: self.getConfValue("COLOR_PRIMARY")
                },
              ]
            },
          ]
        },
      };

      if (logoBaseUrl) {
        quoteContent.header.unshift({
          image: logoBase64,
          fit: [120, 120],
          alignment: "left",
          margin: [40, 20, 40, 0],
        })
      }

      pdfMake.createPdf(quoteContent).download(`Cotización-${response.correlationId}`);
    },
    getTableData(response) {
      let products = [...response.items],
        data = [],
        subList = [];

      let { totalPlusDelivery } = response

      products.forEach(async (item) => {
        // let productImage = await this.getImageToPdf(item.productImage)

        let obj = {
          // image: productImage,
          quantity: item.quantity,
          name: item.productName,
          unitPrice: item.price,
          price: item.price * item.quantity,
        };

        for (const key in obj) {
          if (Object.hasOwnProperty.call(obj, key)) {
            let element = { text: obj[key], margin: [0, 4, 0, 4] };
            if (key == "price" || key == "unitPrice") {
              element = { text: Util.formatNumber(obj[key]), alignment: 'right', margin: [0, 4, 0, 4] };
            } else if (key == "quantity") {
              element = { text: obj[key], alignment: 'center', margin: [0, 4, 0, 4] };
            }
            subList.push(element);
          }
        }

        data.push(subList);
        subList = [];
      });

      if (response.delivery && response.delivery > 0) {
        data.push(
          [
            { text: "1", alignment: 'center', margin: [0, 4, 0, 4] },
            { text: "Servicio de entrega", margin: [0, 4, 0, 4] },
            { text: Util.formatNumber(response.delivery), margin: [0, 4, 0, 4], alignment: 'right' },
            { text: Util.formatNumber(response.delivery), margin: [0, 4, 0, 4], alignment: 'right' }
          ]
        )
      }

      const tableHeader = [
        // { text: "IMAGEN", margin: [0, 4, 0, 4], bold: true },
        { text: "CANT.", margin: [0, 4, 0, 4], bold: true },
        { text: "DESCRIPCIÓN", margin: [0, 4, 0, 4], bold: true },
        { text: "P. UNIT.", margin: [0, 4, 0, 4], bold: true },
        { text: "P. TOTAL", margin: [0, 4, 0, 4], bold: true },
      ];

      tableHeader.forEach((item) => {
        item.fillColor = this.getConfValue("COLOR_PRIMARY");
        item.color = "#FFFFFF";
        item.alignment = "center";
      });

      const tableFooter = [
        [
          { text: "", colSpan: 2, border: [false, false, false, false] },
          "",
          { text: "TOTAL", bold: true, margin: [0, 4, 0, 4] },
          { text: Helpers.formatPrice(totalPlusDelivery), alignment: 'right', bold: true, margin: [0, 4, 0, 4] }
        ],
      ];

      return [tableHeader, ...data, ...tableFooter];
    },
    async getQuoteData(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await QuoteService.get(id);
        if (response.payload) {
          let customer = JSON.parse(JSON.stringify(response.payload));

          let productList = [...response.payload.items]

          return {
            customer,
            productList,
          };
        }
      } catch (ex) {
        let message = ex.errors.message;

        if (message == "No encontrado") {
          message = Constants.Errors.RECORD_NOT_FOUND;
        }

        Alert.error(message, () =>
          this.$router.push({ name: "tools-quotes-list" })
        );
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async getImageToPdf(image) {
      const logoUrl = image

      const response = await fetch(logoUrl);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    getWebsiteUrl: function () {
      return process.env.VUE_APP_WEB_URL;
    }
  },
  computed: {
    ...mapGetters({
      getConfValue: "app/getConfValue"
    })
  }
};